import { PureConnect, React } from '../../../../react';
import { INoteChat, IParticipant } from '../../../../types';
import cx from './style.less';
import { notechatEditor, notechatResource } from '../../resource';
import { DateTimeText } from '../../../../shared/date';
import NOTECHAT_TOGGLE_MENU from '../../actions/NOTECHAT_TOGGLE_MENU';
import NOTECHATATTACHED_TOGGLE_MENU from '../../actions/NOTECHATATTACHED_TOGGLE_MENU';
import MiniMenu, { MiniMenuItem } from '../../../../react-toolbox-extended/mini-menu';
import adminReselectors from '../../../admin/reselectors';

export default PureConnect<{ item: INoteChat, 
            flyoverVisible?: boolean,
            participant: IParticipant, 
            visible?: boolean }>('DataItemNoteChat')(
    (state, props) => ({
        showMiniMenuChat: state.notechat.showMiniMenuChat,
        itemMiniMenuChat: state.notechat.itemMiniMenuChat,
        allParticipants: adminReselectors.participantsSelector(state),
        allChats: notechatResource.selectors.items(state),
    }),
    (dispatch) => ({
        toggleMiniMenu: (showMiniMenuChat: boolean, itemMiniMenuChat: INoteChat) => {         
            dispatch(NOTECHAT_TOGGLE_MENU({ showMiniMenuChat, itemMiniMenuChat })); 
        },
        removeChat: (item: INoteChat) => dispatch(notechatEditor.actions.DELETE_CONTINUE({item})),
        updateChat: (item: INoteChat) => dispatch(notechatEditor.actions.UPDATE_CONTINUE({item})),
        updateBatchChat: (items: INoteChat[]) => items.forEach((item) => dispatch(notechatResource.actions.UPDATE({ item }))),
        editChat: (item: INoteChat) => dispatch(notechatEditor.actions.UPDATE({ item })),
    }),
    ({ item, allChats, participant, allParticipants, visible, editChat, updateBatchChat, showMiniMenuChat, toggleMiniMenu, removeChat, updateChat, itemMiniMenuChat, flyoverVisible }) => {

        const toggle = () => {
            showMiniMenuChat=!showMiniMenuChat;
            toggleMiniMenu(showMiniMenuChat, item);
        }; 

        const currentUser =  allParticipants.qWhere((i)=>i.isUser).qFirst();        

        const itms: MiniMenuItem[] = currentUser&&item&&item.id&&item.userId===currentUser.id ? 
            [ { name:'Verwijderen', iconName:'delete', key: item.id.toString() + 'a', functionitem:item, function: (item: INoteChat) => {
                toggle();
                return removeChat(item);
            }},
            { name:'Vastmaken', iconName:'chain', key: item.id.toString() + 'b', functionitem:item, function: (item: INoteChat) => {
                toggle();

                    item.attached=true;
                    return updateChat(item);

            }},
            { name:'Bewerken', iconName:'edit', key: item.id.toString() + 'c', functionitem:item, function: (item: INoteChat) => {
                toggle();
                return editChat(item);
            }} ] : currentUser&&item&&item.id&&item.userId!==currentUser.id ?
            [
                { name:'Vastmaken', iconName:'chain', key: item.id.toString() + 'b', functionitem:item, function: (item: INoteChat) => {
                    toggle();

                        item.attached=true;
                        return updateChat(item);

                }},
            ]:
            [];   
       
        return ( 
            <li className={cx('data-item-chat', flyoverVisible ? 'flyover-chat-item' : 'modal-chat-item')} tabIndex={visible? -1: 0}>
                <div className={cx('data-item-outer-container')}> 
                    <div className={cx('top-container')}>
                        <div className={cx('icon-container')}>
                            <span className={cx('icon-shared')}></span>
                        </div>
                        <div className={cx('info_container')}>
                            <span className={cx('autho-name')}>{participant ? participant.name + ', ' : ''}<DateTimeText date={item.created} /></span>
                            {/* <span className={cx('created')}><DateTimeText date={item.created} /></span> */}
                        </div>
                        <div className={cx('button-container')}>
                            <MiniMenu showMiniMenu={showMiniMenuChat && (item.id === (itemMiniMenuChat ? itemMiniMenuChat.id : ''))} 
                                    toggleMiniMenu={() => toggle()}
                                    items={itms}>
                            </MiniMenu>
                        </div>
                        
                    </div>
                    <div className={cx('bottom-container')}>
                        <div className={cx('text-container_main')}>{item.text}</div>
                    </div>
                </div>
            </li>
        );
    },
);

export const ChainedChat = PureConnect<{noteId: number}>(`ChainedChat`)(
(state) => ({
    noteChats: notechatResource.selectors.items(state),
    participants: adminReselectors.participantsSelector(state),  
    showMiniMenuChatAttached: state.notechat.showMiniMenuChatAttached,
    itemMiniMenuChatAttached: state.notechat.itemMiniMenuChatAttached,
    allParticipants: adminReselectors.participantsSelector(state),
}),
(dispatch) => ({ 
    toggleMiniMenu: (showMiniMenuChatAttached: boolean, itemMiniMenuChatAttached: INoteChat) => {         
        dispatch(NOTECHATATTACHED_TOGGLE_MENU({ showMiniMenuChatAttached, itemMiniMenuChatAttached })); 
    },
    removeChat: (item: INoteChat) => dispatch(notechatEditor.actions.DELETE_CONTINUE({item})),
    updateChat: (item: INoteChat) => dispatch(notechatEditor.actions.UPDATE_CONTINUE({item})),
    editChat: (item: INoteChat) => dispatch(notechatEditor.actions.UPDATE({ item })),
}),
({ noteId, noteChats, participants, showMiniMenuChatAttached, itemMiniMenuChatAttached, allParticipants, toggleMiniMenu, removeChat, updateChat, editChat }) => {        
    var attached = noteChats.qWhere((itm)=>itm.attached && noteId===itm.noteId).qFirst();
    var attachedParticipant;
    if (attached) {
        attachedParticipant = participants.qWhere((itm)=>itm.id===attached.userId).qFirst();
        attached.text = !attached.text ? '': attached.text; 
    }
    const toggle = () => {
        showMiniMenuChatAttached=!showMiniMenuChatAttached;
        toggleMiniMenu(showMiniMenuChatAttached, attached);
    }; 

    const currentUser =  allParticipants.qWhere((i)=>i.isUser).qFirst();        

    const itemsattached: MiniMenuItem[] = currentUser&&attached&&attached.id&&attached.userId===currentUser.id ? 
        [ { name:'Verwijderen', iconName:'delete', key: '1', functionitem:attached, function: (item: INoteChat) => {
            toggle();
            return removeChat(attached);
        }},
        { name:'Reactie losmaken', iconName:'chain', key: '2', functionitem:attached, function: (item: INoteChat) => {
            toggle();
            item.attached=false;
            return updateChat(attached);
        }},
        { name:'Bewerken', iconName:'edit', key: '3', functionitem:attached, function: (item: INoteChat) => {
            toggle();
            return editChat(attached);
        }} ] : currentUser&&attached&&attached.id&&attached.userId!==currentUser.id ?
        [
        { name:'Reactie losmaken', iconName:'chain', key: '2', functionitem:attached, function: (item: INoteChat) => {
            toggle();
            attached.attached=false;
            return updateChat(attached);
        }}] :
        [] ;   

    return ( 
            attached? 
                <div className={cx('data-item-chat-attached')}> 
                    <div className={cx('attached-top-container')}>
                        <div className={cx('attached-info-container')}>
                            <span className={cx('attached-title')}>Vastgemaakte reactie</span>
                            <div className={cx('button-container')}>
                                <MiniMenu showMiniMenu={showMiniMenuChatAttached}                                 
                                    toggleMiniMenu={() => toggle()}
                                    items={itemsattached}>
                                </MiniMenu>
                            </div>
                        </div>
                        <div className={cx('icon-container')}>
                            <span className={cx('icon-shared')}></span>
                        </div>
                        <div className={cx('attached-info_container')}>
                            <span className={cx('autho-name')}>{attachedParticipant? attachedParticipant.name + ', ' : ''}<DateTimeText date={attached.created} /></span>                            
                        </div>
                        
                    </div>
                    <div className={cx('attached-bottom-container')}>
                        <div className={cx('text-container_main')}>{attached.text}</div>
                    </div>
                </div>
            :
            null
    );
},
);

/* tslint:disable-next-line */
function handleKeyDown(evt: React.KeyboardEvent<HTMLElement>, functionEsc: Function, functionEnter: Function) {
    if (evt.key==='Escape') { evt.preventDefault(); functionEsc(); }
    if (evt.key==='Enter') { evt.preventDefault(); functionEnter(); }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notechat/notechatdatalist/dataitemchat/index.tsx